interface EyebrowProps {
  children: React.ReactNode;
}

export function Eyebrow({ children }: EyebrowProps) {
  return (
    <span className="eyebrow">
      <span className="eyebrow__dot" />
      {children}
    </span>
  );
}
